package no.vareflow.app.data.local

import no.vareflow.app.data.json.Json
import no.vareflow.app.domain.nowMillis
import no.vareflow.app.sync.PendingCountWrite

/**
 * Durable storage format of the count outbox (key "count_outbox"), shared by phone and browser.
 * Keep field names stable: queued writes from older app versions must still load.
 */
object CountOutboxCodec {

    /** Missing or damaged text gives an empty queue (same as the Android version). */
    fun fromJson(raw: String?): List<PendingCountWrite> {
        if (raw == null) return emptyList()
        return runCatching {
            val array = Json.parseArray(raw)
            buildList {
                repeat(array.length()) { index ->
                    val o = array.getObject(index)
                    add(
                        PendingCountWrite(
                            eventId = o.getString("eventId"),
                            companyId = o.getString("companyId"),
                            locationId = o.getString("locationId"),
                            sessionId = o.getString("sessionId"),
                            productId = o.getString("productId"),
                            departmentId = o.optString("departmentId", "bar"),
                            quantity = if (o.isNull("quantity")) null else o.getDouble("quantity"),
                            note = o.optString("note"),
                            actorUserId = o.getString("actorUserId"),
                            actorName = o.optString("actorName"),
                            baseVersion = o.optInt("baseVersion", 0),
                            createdAt = o.optLong("createdAt", nowMillis()),
                            resolutionOfConflictId = o.optString("resolutionOfConflictId").takeIf { it.isNotBlank() }
                        )
                    )
                }
            }
        }.getOrDefault(emptyList())
    }

    fun toJson(items: List<PendingCountWrite>): String = Json.write(items.map { write ->
        linkedMapOf(
            "eventId" to write.eventId,
            "companyId" to write.companyId,
            "locationId" to write.locationId,
            "sessionId" to write.sessionId,
            "productId" to write.productId,
            "departmentId" to write.departmentId,
            "quantity" to write.quantity,
            "note" to write.note,
            "actorUserId" to write.actorUserId,
            "actorName" to write.actorName,
            "baseVersion" to write.baseVersion,
            "createdAt" to write.createdAt,
            "resolutionOfConflictId" to (write.resolutionOfConflictId ?: "")
        )
    })
}
